module.exports = __webpack_public_path__ + "static/media/calendar.ca0ec0c1.svg";